import { combineReducers } from 'redux';
import scene, { SceneState } from "~/reducers/scene";

export default combineReducers<ApplicationStore>({
  scene
});

export interface ApplicationStore {
  scene: SceneState;
}